<template>
  <div class="animated fadeIn">
    <div class="title font-300 font-24 mb-15">
      {{ this.$route.name }}
    </div>
    <div class="box">
      <div class="p-15 pb-0">
        <div class="row">
          <div class="col-sm-6">
            <table>
              <tr>
                <td><a @click="exportReport()" class="btn-primary mr-5"><i class="far fa-file-alt mr-5"></i>Export</a>
                </td>
                <td>
                  <flat-pickr @on-change="onChange" :config="exportConfig" class="font-13" v-model="exportDates"
                    name="export_date_start"></flat-pickr>
                </td>
                <td>
                  <b-form-select name="branch" v-model="branch_id" @change="changeBranch" :disabled="isBranchLocked">
                    <option :value="null">All Branch PT</option>
                    <option v-for="item in dataBranch" :key="item.id" :value="item.id">{{ item.name }}</option>
                  </b-form-select>
                </td>
              </tr>
            </table>
          </div>
        </div>
      </div>
      <hr class="mb-0">
      <div class="p-15 pt-0">
        <b-table :hover="hover" :striped="striped" :bordered="bordered" :small="small" :fixed="fixed"
          responsive="sm" :items="items" :fields="fields" :per-page="perPage" :current-page="currentPage">
        </b-table>
        <b-pagination v-if="items.length > perPage" class="pagination-custom mt-20" v-model="currentPage"
          :total-rows="items.length" :per-page="perPage"></b-pagination>
      </div>
    </div>

    <div v-if="loadingActive == true" class="loading-container">
      <div class="wrap-screen w-100 h-100">
        <img :src="`/svg-loaders/oval.svg`" width="60" alt="" />
        <div class="title-loading color-white">Loading...</div>
      </div>
    </div>

  </div>
</template>

<script>
import moment from 'moment'
import axios from 'axios'
import { Auth } from '@/api'

export default {
  name: 'ptFeedbackReport',
  props: {
    hover: {
      type: Boolean,
      default: true
    },
    striped: {
      type: Boolean,
      default: true
    },
    bordered: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    fixed: {
      type: Boolean,
      default: false
    }
  },
  data: () => {
    return {
      loadingActive: false,
      fields: [
        { key: 'submit_date', label: 'Submit Date', sortable: false },
        { key: 'submit_time', label: 'Submit Time', sortable: false },
        { key: 'member_id', label: 'Member ID', sortable: false },
        { key: 'branch_club_member', label: 'Branch Club Member', sortable: false },
        { key: 'member_name', label: 'Member Name', sortable: false },
        { key: 'age', label: 'Age', sortable: false },
        { key: 'type_membership', label: 'Type Membership', sortable: false },
        { key: 'status_membership', label: 'Status Membership', sortable: false },
        { key: 'branch_pt', label: 'Branch PT', sortable: false },
        {
          key: 'pt_session_date',
          label: 'PT Session Date, Time',
          sortable: false,
          formatter: (value, key, item) => {
            return value ? value + ' ' + (item.pt_session_time || '') : '-'
          }
        },
        { key: 'pt_session_with', label: 'PT Session With', sortable: false },
        { key: 'rating', label: 'Rating', sortable: false },
        { key: 'feedback', label: 'Feedback', sortable: false }
      ],
      items: [],
      currentPage: 1,
      perPage: 20,
      branch_id: null,
      // Role PT: filter branch dikunci mengikuti branch Personal Trainer yang login.
      isBranchLocked: false,
      dataBranch: [],
      exportDates: (moment().startOf('month').format('YYYY-MM-DD')) + ' to ' + (moment().endOf('month').format('YYYY-MM-DD')),
      exportConfig: {
        mode: 'range',
        dateFormat: 'Y-m-d',
        altInput: true,
        altFormat: 'd/m/y',
        defaultDate: [moment().startOf('month').format('YYYY-MM-DD'), moment().endOf('month').format('YYYY-MM-DD')]
      }
    }
  },
  methods: {
    exportReport() {
      this.loadingActive = true
      const dates = this.exportDates.split(' to ')
      let url = 'crm/v1/export/report/pt_feedback?start=' + dates[0] + '&end=' + dates[1]
      if (this.branch_id != null) {
        url += '&branch_id=' + this.branch_id
      }
      axios({
        method: 'get',
        url: url,
        responseType: 'arraybuffer'
      }).then(response => {
        this.loadingActive = false
        let blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
        let link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        link.download = 'PT Feedback Report ' + moment(dates[0]).format('DD MMM YYYY') + ' - ' + moment(dates[1]).format('DD MMM YYYY') + '.xlsx'
        link.click()
      }).catch(error => {
        this.loadingActive = false
        console.log('error', error)
      })
    },
    onChange(selectedDates, dateStr) {
      if (selectedDates.length === 2) {
        this.exportDates = typeof selectedDates[0] === typeof selectedDates[1] ? dateStr + ' to ' + dateStr : dateStr
        if (this.exportDates.includes(' to ')) {
          this.fetchData()
        }
      }
    },
    changeBranch() {
      this.fetchData()
    },
    fetchData() {
      this.loadingActive = true
      this.currentPage = 1
      const dates = this.exportDates.split(' to ')
      let url = 'crm/v1/pt_feedback_report?start=' + dates[0] + '&end=' + dates[1]
      if (this.branch_id != null) {
        url += '&branch_id=' + this.branch_id
      }
      axios.defaults.headers.common['X-Access-Token'] = Auth.Session.get().paradigm_token
      axios.get(url).then(response => {
        this.items = response.data.data
        this.loadingActive = false
      }).catch(error => {
        this.loadingActive = false
        console.log('error', error)
      })

      axios.get('fitness/v1/branch/').then(response => {
        this.dataBranch = response.data.data.rows
      }).catch(error => {
        console.log('error', error)
      })
    }
  },
  created() {
    const ptRoleIds = [7, 9, 18, 22, 31, 21]
    const session = Auth.Session.get()
    const ptBranchId = Number(session.paradigm_branch_id)
    if (ptRoleIds.includes(Number(session.paradigm_role)) && ptBranchId) {
      this.branch_id = ptBranchId
      this.isBranchLocked = true
    }
    this.fetchData()
  }
}
</script>

<style></style>
